import axios from "axios";
import router from "@/router";

const request = axios.create({
    baseURL: process.env.VUE_APP_HOST_API,
    timeout: 60 * 10 * 1000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        // "access-token": localStorage.getItem('token'),
    },
})

//请求拦截
request.interceptors.request.use(config => {
    // config.headers['Content-Type'] = 'application/json';
    config.headers['access-token'] = localStorage.getItem('token');
    return config;
},
    (error) => {
        throw new Error(error) // 将错误信息抛出
        console.error('error', error)     // 将错误信息打印到控制台 
        Promise.reject(error)
    }
)
// 响应拦截
request.interceptors.response.use((res) => {
    // return res.data;
    if (res.data.code != 200) {
        localStorage.removeItem('token');
        router.push('/login');
    } else {
        return res.data;
    }

},
    (error) => {
        Promise.resolve(error);
    }
)

export default request;